import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';

import Home from '../pages/Home';
import Login from '../pages/users/Login';
import ForgotPassword from '../pages/users/ForgotPassword';
import ResetPassword from '../pages/users/ResetPassword';

import Report from '../pages/sys/Report';

import PrintTableWithHeader from '../components/PrintReport';

import ReportForm from '../pages/sys/ReportForm';
import UserPermission from '../pages/users/UserPermission';

import PortalForm from '../pages/sys/PortalForm';
import InvoicePage from '../pages/sys/Invoice';
import UserProfile from '../pages/users/UserProfile';
import Documentation from '../pages/sys/Documentation';
import BalanceSheet from '../pages/sys/Accounting/BalanceSheet';
import SysFeatures from '../pages/sys/SysFeatures';
import MultiEntryForm from '../pages/sys/MultiEntryForm';
import CSVUploader from '../pages/sys/CSVUploader';
import VerifyEmail from '../pages/users/VerifyEmail';
import Register2Fa from '../pages/users/Register2FA';
import Check2FA from '../pages/users/Check2FA';
import IncomeStatement from '../pages/sys/Accounting/IncomeStatement';

import LoginDocumentation from '../pages/users/LoginDocumentation';
import PortalPromo from '../pages/custom/PortalPromo';
import SqlViewer from '../pages/sys/SqlViewer';
import ActivityReport from '../pages/sys/ActivityReport';
import SqlHome from '../pages/sql/Home';
import ApiDocumentation from '../pages/sys/ApiDocumentation';

import ElectionPage from '../pages/custom/Election';
import ElectionResults from '../pages/custom/ElectionResult';
import ElectionLiveResults from '../pages/custom/ElectionLiveResult';

import CustomerCareDashboard from '../components/CustomerCareDashboard';

import WebRenderer from '../pages/web/WebRenderer';
import POSPage from '../pages/pos/POSPage';
import PosInvoice from '../pages/sys/PosInvoice';
import PosPendingInvoice from '../pages/sys/PosPendingInvoice';
import PrivacyPolicy from '../pages/privacy/PrivacyPolicy';
import DoctorPortal from '../pages/caafi/DoctorPortal';

import LabTestRequest from '../pages/caafi/LabTestRequest';
import PassCard from '../pages/aqoonkaal/PassCard';
import SalesInvoice from '../pages/sys/SalesInvoice';
import MultiEntryForm2 from '../pages/sys/MultiEntryForm2';
import MultiEntryForm3 from '../pages/sys/MultiEntryForm3';
import SalesPurchase from '../pages/sys/SalesPurchase';
import QrCodeProfile from '../pages/sys/QrCodeProfile';

import DetailCategoryLette from '../pages/caafi/Detail_category_Letter';
import SummaryCategoryLetter from '../pages/caafi/Summary_category_letter';
import SalesPurchaseNoPaid from '../pages/sys/SalesPurchaseNoPaid';
import RegistrationLetter from '../pages/aqoonkaal/RegistrationLetter';
import MaternityDeliveryNote from '../pages/caafi/DelivertNote';

import KaafiPayWeb from '../pages/web/KaafiPay/KaafiPay';
import { API_URL } from '../constants/api';
import GalmudugWeb from '../pages/web/galmudug/Galmudug';
import ElearnigHomePage from '../pages/ELearning/Ehomepage';
import About from '../pages/ELearning/about';
import Contact from '../pages/ELearning/contac';
import Program from '../pages/ELearning/programs';
import AdmissionRequirements from '../pages/ELearning/admission requirement';
import DepartmentTable from '../pages/ELearning/course_detail_table';

import StudentReceiptInvoice from '../pages/aqoonkaal/ReceiptInvoice';
import QuestionPage from '../pages/ELearning/QuestionPage';
import CourseDetail from '../pages/ELearning/CourseDetail';
import QuixPage from '../pages/ELearning/quiz';
import QuestionPreview from '../pages/ELearning/PreviewQuestion';
import CameraView from '../pages/ELearning/CameraTest';

import ClassPassCard from '../pages/aqoonkaal/ClassPassCard';
import ClassPassCard2 from '../pages/aqoonkaal/ClassPassCard2';
import PassCard2 from '../pages/aqoonkaal/Passcard2';
import InvoiceBook from '../pages/web/KaafiPay/InvoiceBook';

import PortalApp from '../pages/ELearning/portal_app';
import KtcElearnigHomePage from '../pages/KTC Elearning/KtcEhomepage';
import KtcAbout from '../pages/KTC Elearning/ktc_about';
import KtcAdmissionRequirements from '../pages/KTC Elearning/ktcadmission requirement';
import KtcContact from '../pages/KTC Elearning/ktccontac';
import KtcProgram from '../pages/KTC Elearning/ktcprograms';
import KtcPortalApp from '../pages/KTC Elearning/ktc_portal_app';
import ExamCamera from '../pages/ELearning/CameraTest';
import ExamStudent from '../pages/ELearning/ExamStuden';
import ExamAdmin from '../pages/ELearning/ExamAdmin';

import StudentReceiptInvoice2 from '../pages/aqoonkaal/ReceiptInvoice2';
import KtcQuestionPage from '../pages/KTC Elearning/ktcQuestionPage';
import Certificate from '../pages/KTC Elearning/Certificate';

import GenerateQrCode from '../pages/custom/GenerateQrCode';
import GenerateCertificate from '../pages/certificates/GenerateCertificate';
import UploadCertificates from '../pages/certificates/UploadCertificate';
import CustomReceiptForm from '../pages/aqoonkaal/CustomReceiptForm';
import CustomParentReceipt from '../pages/aqoonkaal/CustomParentReceipt';
import CancelReceipt from '../pages/aqoonkaal/CancelReceipt';
import CancelBusReceipt from '../pages/aqoonkaal/CancelBusReceipt';
import { ComplaintLetter } from '../components/ComplaintLetter';
import MultiEntryJson from '../pages/sys/MultiEntryJson';
import ExamStudents from '../pages/KTC Elearning/ExamStudents';
import KaafiPayRoutes from './Kaafipay';
import IDCardRoutes from './Id';
import MultiRowPrint from '../pages/caafi/MultiRowPrint';

// import Tracking from '../pages/custom/Tracking';

// console.log('api_url me', API_URL);
const AppRoutes = () => {
  function StartupRedirect() {
    const allowedSubdomains = ['customer', 'portal', 'student', 'elearn'];
    const pathName = window.location.href;
    // console.log('path', pathName);
    const hostname = window.location.hostname; // e.g., 'customer.example.com'
    const parts = hostname.split('.'); // e.g., ['customer', 'example', 'com']
    // console.log('parts:', parts);
    if (parts.length <= 2) {
      // Example: localhost or example.com
      if (API_URL.includes('galmudug') || API_URL.includes('hirshabeele')) {
        return <GalmudugWeb />;
      }
      return <KaafiPayWeb />;
    }

    const subdomain = parts[0];
    console.log('subdomain: ', subdomain);
    if (
      subdomain === 'customer' ||
      subdomain === 'portal' ||
      subdomain === 'student'
    ) {
      return <Navigate to={`/login/${subdomain}-login`} replace />;
    }

    if (subdomain == 'elearn') {
      return <Navigate to="elearningHome"></Navigate>;
    }
    if (pathName.includes('https://newktc.kaafi.net/Certificate/')) {
      window.location.href = pathName;
      return null;
    }
    if (pathName.includes('https://portal.kaafi.net')) {
      
      return <Navigate to="/login/portal-login" replace /> ;
    }

    return <Navigate to="/login/user-login" replace />;
  }
  return (
    <Routes>
      {/* <Route path="/" element={<Login />} /> */}
      <Route path="/" element={<StartupRedirect />} />

      <Route path="/login/:loginRoute" element={<Login />} />
      <Route
        path="/forgot-password/:forgotRoute"
        element={<ForgotPassword />}
      />
      <Route path="/reset-password/:token" element={<ResetPassword />} />
      <Route path="/verify-email/:token" element={<VerifyEmail />} />
      <Route path="/register-2fa" element={<Register2Fa />} />
      <Route path="/check-2fa" element={<Check2FA />} />
      <Route
        path="/login-documentation/:email"
        element={<LoginDocumentation />}
      />

      <Route path="/profile" element={<UserProfile />} />
      <Route path="/documentation/:_id/:type" element={<Documentation />} />
      <Route path="/sys-features/:_id/:type" element={<SysFeatures />} />

      <Route path="/report/balance-sheet" element={<BalanceSheet />} />

      <Route
        path="/form-report/permission/:route"
        element={<UserPermission />}
      />

      <Route path="/portal/:route" element={<PortalForm />} />
      <Route path="/invoice/:route/:id" element={<InvoicePage />} />
      {/* <Route path="/tracking/:route" element={<Tracking />} /> */}

      <Route path="/home" element={<Home />} />
      <Route path="/print" element={<PrintTableWithHeader />} />
      <Route path="/print-activity" element={<ActivityReport />} />

      <Route path="/report/:route" element={<Report />} />
      <Route path="/app-list/:route" element={<Report />} />

      <Route path="/form-report/:route" element={<ReportForm />} />
      <Route path="/activity-report/:route" element={<ReportForm />} />
      <Route path="/map-report/:route" element={<ReportForm />} />
      <Route path="/multi-entry/:route" element={<MultiEntryForm />} />
      <Route path="/multi-entry2/:route" element={<MultiEntryForm2 />} />
      <Route
        path="/multi-entry3/:route"
        element={<MultiEntryForm3></MultiEntryForm3>}
      ></Route>
      <Route path="/multi-entry-json/:route" element={<MultiEntryJson />} />
      <Route path="/sales-purchase/:route" element={<SalesPurchase />} />
      <Route
        path="/sales-purchase-nopaid/:route"
        element={<SalesPurchaseNoPaid />}
      />

      <Route path="/report/ktc-sql" element={<SqlHome />} />
      <Route path="/csv-uploader/:route" element={<CSVUploader />} />

      <Route path="/report/income-statement" element={<IncomeStatement />} />
      {/* KaafiPay to WebRenderer */}
      <Route path="/web" element={<WebRenderer />} />
      <Route path="/pos" element={<POSPage />} />
      <Route path="/pos-invoice/:route/:id" element={<PosInvoice />} />
      <Route path="/sales-invoice/:route/:id" element={<SalesInvoice />} />
      <Route
        path="/student-invoice/:route/:id"
        element={<StudentReceiptInvoice />}
      />
      <Route
        path="/student-invoice/:route/:fee_id/:id"
        element={<StudentReceiptInvoice2 />}
      />
      <Route path="/pos-invoice/:route/" element={<PosPendingInvoice />} />
      <Route path="/passcard/:route/:id/:exam_id" element={<PassCard />} />
      <Route path="/passcard2/:route/:id/:exam_id" element={<PassCard2 />} />
      <Route
        path="/class-passcard/:route/:class_id"
        element={<ClassPassCard />}
      />
      <Route
        path="/class-passcard2/:route/:class_id"
        element={<ClassPassCard2 />}
      />
      <Route
        path="/registration-letter/:route/:id/"
        element={<RegistrationLetter />}
      />
      <Route path="/portal-promo" element={<PortalPromo />} />
      <Route path="/report/sql-updates" element={<SqlViewer />} />
      <Route
        path="/api-documentation/:link_id"
        element={<ApiDocumentation />}
      />
      <Route path="/election/candidates" element={<ElectionPage />} />
      <Route path="/election/results" element={<ElectionResults />} />
      <Route path="/election/live-results" element={<ElectionLiveResults />} />

      <Route path="/ccDashboard" element={<CustomerCareDashboard />} />

      <Route path="/privacy-policy" element={<PrivacyPolicy />} />

      {/*Cafai routes*/}
      <Route path="/doctor-portal" element={<DoctorPortal />} />

      <Route
        path="/lab-test-request/:route/:appointment_id"
        element={<LabTestRequest />}
      />

      <Route path="/qrcode/:route/:id" element={<QrCodeProfile />} />
      <Route
        path="/detailCategoryLetter/:route/:id"
        element={<DetailCategoryLette />}
      />
       <Route
        path="/multiRowPrint/:route/:id"
        element={<MultiRowPrint></MultiRowPrint>}
      />
      <Route
        path="/summaryCategoryLetter/:route/:id"
        element={<SummaryCategoryLetter />}
      />
      <Route
        path="/MaternityDeliveryNote/:id"
        element={<MaternityDeliveryNote />}
      />
      <Route
        path="/elearningHome"
        element={<ElearnigHomePage></ElearnigHomePage>}
      ></Route>
      <Route path="/about" element={<About></About>}></Route>
      <Route path="/contact" element={<Contact></Contact>}></Route>
      <Route path="/programs" element={<Program></Program>}></Route>
      <Route
        path="/admssionRequirement"
        element={<AdmissionRequirements />}
      ></Route>
      <Route
        path="/department/:departmentId"
        element={<DepartmentTable />}
      ></Route>
      <Route path="/student-portal" element={<PortalApp />}></Route>
      <Route path="/questions" element={<QuestionPage />}></Route>
      <Route path="/coursedetails/:courseId" element={<CourseDetail />} />
      <Route path="/quiz" element={<QuixPage />}></Route>
      <Route path="/cameraView" element={<CameraView />} />
      <Route path="/live-exam-students" element={<ExamStudents />} />

      <Route
        path="/QuestionPreview/:class_id/:semester_id/:course_id/:exam_type"
        element={<QuestionPreview />}
      />

      <Route
        path="/elearningHome"
        element={<ElearnigHomePage></ElearnigHomePage>}
      ></Route>
      <Route path="/about" element={<About></About>}></Route>
      <Route path="/contact" element={<Contact></Contact>}></Route>
      <Route path="/programs" element={<Program></Program>}></Route>
      <Route
        path="/admssionRequirement"
        element={<AdmissionRequirements></AdmissionRequirements>}
      ></Route>
      <Route
        path="/department/:departmentId"
        element={<DepartmentTable></DepartmentTable>}
      ></Route>

      <Route path="/invoice-book" element={<InvoiceBook />}></Route>

      <Route path="/ktcEHome" element={<KtcElearnigHomePage />}></Route>
      <Route path="/ktcAbout" element={<KtcAbout></KtcAbout>}></Route>
      <Route
        path="/ktcadmssionRequirement"
        element={<KtcAdmissionRequirements></KtcAdmissionRequirements>}
      ></Route>
      <Route path="/ktcContact" element={<KtcContact></KtcContact>}></Route>
      <Route path="/ktcProgram" element={<KtcProgram></KtcProgram>}></Route>
      <Route path="/ktcPortal" element={<KtcPortalApp></KtcPortalApp>}></Route>
      <Route path="/ExamCamere" element={<ExamCamera></ExamCamera>}></Route>
      <Route path="/ExamStudent" element={<ExamStudent></ExamStudent>}></Route>
      <Route path="/ExamAdmin" element={<ExamAdmin></ExamAdmin>}></Route>

      <Route path="/qr-code" element={<GenerateQrCode />} />
      <Route path="/generate-certificate" element={<GenerateCertificate />} />
      <Route path="/upload-certificate" element={<UploadCertificates />} />

      <Route
        path="/cancel-receipt/:fee_id/:ref_no"
        element={<CancelReceipt />}
      />
      <Route
        path="/cancel-bus-receipt/:fee_id/:ref_no"
        element={<CancelBusReceipt />}
      />
      <Route path="/ktcEHome" element={<KtcElearnigHomePage />}></Route>
      <Route path="/ktcAbout" element={<KtcAbout></KtcAbout>}></Route>
      <Route
        path="/ktcadmssionRequirement"
        element={<KtcAdmissionRequirements></KtcAdmissionRequirements>}
      ></Route>

      <Route path="/ktcContact" element={<KtcContact></KtcContact>}></Route>
      <Route path="/ktcProgram" element={<KtcProgram></KtcProgram>}></Route>
      <Route path="/ktcPortal" element={<KtcPortalApp></KtcPortalApp>}></Route>
      <Route path="/ExamCamere" element={<ExamCamera></ExamCamera>}></Route>
      <Route path="/ExamStudent" element={<ExamStudent></ExamStudent>}></Route>
      <Route path="/ExamAdmin" element={<ExamAdmin></ExamAdmin>}></Route>
      <Route
        path="/ktcquestions"
        element={<KtcQuestionPage></KtcQuestionPage>}
      ></Route>
      <Route
        path="/Certificate/:certificate_id"
        element={<Certificate></Certificate>}
      ></Route>

      <Route path="/ktcEHome" element={<KtcElearnigHomePage />}></Route>
      <Route path="/ktcAbout" element={<KtcAbout></KtcAbout>}></Route>
      <Route
        path="/ktcadmssionRequirement"
        element={<KtcAdmissionRequirements></KtcAdmissionRequirements>}
      ></Route>
      <Route path="/ktcContact" element={<KtcContact></KtcContact>}></Route>
      <Route path="/ktcProgram" element={<KtcProgram></KtcProgram>}></Route>
      <Route path="/ktcPortal" element={<KtcPortalApp></KtcPortalApp>}></Route>
      <Route path="/ExamCamere" element={<ExamCamera></ExamCamera>}></Route>
      <Route
        path="/ExamStudent/:studentId"
        element={<ExamStudent></ExamStudent>}
      ></Route>
      <Route path="/ExamAdmin" element={<ExamAdmin></ExamAdmin>}></Route>

      <Route path="/qr-code" element={<GenerateQrCode />} />
      <Route path="/generate-certificate" element={<GenerateCertificate />} />
      <Route path="/upload-certificate" element={<UploadCertificates />} />

      <Route
        path="/complaint-letter/:route/:id"
        element={<ComplaintLetter />}
      />

      {/* Include all KaafiPay routes */}
      <Route path="/kaafipay/*" element={<KaafiPayRoutes />} />
      {/* Include all KaafiPay routes */}
      <Route path="/idcard/*" element={<IDCardRoutes />} />
    </Routes>
  );
};

export default AppRoutes;
